<template>
  <v-container fluid class="pa-0">
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </div>

    <div class="d-flex flex-column justify-center align-center">

      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-text class="d-flex flex-column justify-center align-center text-center" v-html="$t('pages.error.full')">
       
          </v-card-text>
        </v-card>
        
<!--        <v-alert
            class="mt-3"
            text
            tile
            type="error"
        >
          <p>
            Neem even contact op met je HR-verantwoordelijke of met Move To Happiness via <a href="mailto:rose@movetohappiness.com">rose@movetohappiness.com</a>.
            <br/>
            Zo kan ook jij van start gaan met jouw road to happiness!
          </p>
        </v-alert>-->


      </div>

    </div>

    
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
export default {
  i18n: i18n,
  name: "m2h-error",
  props: [],
  components: {},
  data() {
    return {
      isLoading: false,
    }
  },
  mounted() {
  },

  methods: {
  }
}
</script>

<style scoped>

</style>
